import React from 'react';

const Dashboard: React.FC = () => {
  return (
    <div className="p-4">
      <h2 className="text-2xl font-bold mb-2">Dashboard</h2>
      <p>Welcome to the Admin Dashboard. This is a placeholder page.</p>
    </div>
  );
};

export default Dashboard; 